import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../utils/api";

const fmtTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Europe/London",
  });
};

export default function JourneyEvaluate() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      try {
        setLoading(true);
        setError("");
        const resp = await api.get(`/api/ema/v2/journey/${token}/evaluate`);
        if (!mounted) return;
        setPayload(resp.data?.data || null);
      } catch (e) {
        if (!mounted) return;
        setError(e?.response?.data?.error || e?.message || "Could not load journey");
      } finally {
        if (mounted) setLoading(false);
      }
    };
    if (token) run();
    return () => {
      mounted = false;
    };
  }, [token]);

  const plan = payload?.plan || {};
  const j = payload?.journey || {};
  const recMode = plan?.recommendation?.recommended_mode || null;
  const recSummary = plan?.recommendation?.summary || null;

  return (
    <div style={{ maxWidth: 1100, margin: "24px auto", padding: "0 16px" }}>
      <div style={{ border: "1px solid #e2e8f0", borderRadius: 14, background: "#fff", padding: 16 }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: "#0369a1", textTransform: "uppercase", letterSpacing: 0.4 }}>
          Journey Monitor
        </div>
        {loading && <div style={{ marginTop: 8, color: "#475569" }}>Loading journey...</div>}
        {!loading && error && <div style={{ marginTop: 8, color: "#b91c1c" }}>{error}</div>}
        {!loading && !error && (
          <div style={{ marginTop: 8, display: "grid", gap: 8 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: "#0f172a" }}>
              {j.flight_number || "Flight"} • {String(j.direction || "Departure")}
            </div>
            <div style={{ color: "#334155", fontSize: 14 }}>
              Flight date: {j.flight_date || "—"} • Postcode: {j.postcode || "—"}
            </div>
            <div style={{ color: "#334155", fontSize: 14 }}>
              Airport target: {fmtTime(plan?.airport_guidance?.arrive_by)}
            </div>
            <div style={{ color: "#0f172a", fontSize: 14 }}>
              Recommended mode: <strong>{recMode || "—"}</strong>
            </div>
            {recSummary && <div style={{ color: "#475569", fontSize: 14 }}>{recSummary}</div>}
            <details>
              <summary style={{ cursor: "pointer", color: "#0f172a", fontWeight: 700 }}>View live payload</summary>
              <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, background: "#f8fafc", border: "1px solid #e2e8f0", padding: 10, borderRadius: 8 }}>
                {JSON.stringify(payload, null, 2)}
              </pre>
            </details>
          </div>
        )}
      </div>
    </div>
  );
}

